import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { JwtService } from '../index.service';
import { BehaviorSubject, EMPTY, Observable, Subject, delay, distinctUntilChanged, filter, first, from, interval, map, merge, mergeMap, of, share, skip, switchMap, take, tap, toArray } from 'rxjs';
import { ProfileSetting } from 'src/app/shared/interfaces/profile-setting.interface';
import { Router } from '@angular/router';
import { Profile } from 'src/app/shared/interfaces/profile.interface';

export type AllProfileDetail = {
  "STUDENT": any[];
  "EMPLOYEE": any[];
  "CERTIFICATION": any[];
  "SKILL": any[];
  "SOFTWARE_SKILL": any[];
  "LANGUAGE_SKILL": any[];
  "AWARD": any[];
  "VOLUNTARY_ACTIVITY": any[];
  "BOOK": any[];
  "PROJECT": any[];
}

@Injectable({
  providedIn: 'root'
})
export class ProfileAboutService {
  readonly BASE_URL = environment.BASE_API_URL;
  private profileSettingSubject:BehaviorSubject<ProfileSetting> = new BehaviorSubject(<ProfileSetting>{})
  private profileSettingObs:Observable<ProfileSetting> = this.profileSettingSubject.asObservable()
  public backNextUrl:any = {};
  constructor(
    private http:HttpClient,
    public jwtService:JwtService,
    private router:Router,
  ) {}

  getAllProfileDetail(username:string,is_public:boolean=false):Observable<AllProfileDetail>{
    return this.http.get<AllProfileDetail>(`${this.BASE_URL}user_role/${username}/get_roles/?ordering=-id${is_public ? '&is_public=true' : ''}` )
  }
  getProfileDataByType(username:string,type:string):Observable<AllProfileDetail|any>{
    switch(type){
      case 'edu':
        return this.getStudentsInfo(username)
      case 'cert':
        return this.getCertifications(username)
      case 'skill':
        return this.getSkills(username)
      case 'work':
        return this.getEmployees(username)
      case 'personal':
        return of(null)
      case 'language':
        return this.getLanguageSkills(username)
      default:
        return this.getAllProfileDetail(username)
    }
  }
  getIsProfileOwner(){
    return this.jwtService.getCurrentAccountDataObs().pipe(
      map((data:any)=>{
        let username:string = this.router.url.split('/')[2]
        username = `${username.split('-')[0]}-${username.split('-')[1]}`
        return data.username==username
      })
    )
  }

  private profileStuSub:BehaviorSubject<any> = new BehaviorSubject('loading');
  private profileStuObs$:Observable<any> = this.profileStuSub.asObservable()
  setProfileStu(data:any):void{
    this.profileStuSub.next(data=='loading'?data:this.sortCert(data));
  }
  getProfileStuObs():Observable<any>{
    return this.profileStuObs$.pipe()
  }

  private profileJobSub:BehaviorSubject<any> = new BehaviorSubject('loading');
  private profileJobObs$:Observable<any> = this.profileJobSub.asObservable()
  
  setProfileJob(data:any):void{
    this.profileJobSub.next(data=='loading'?data:this.sortEmployee(data));
  }
  getProfileJobObs():Observable<any>{
    return this.profileJobObs$;
  }

  private profileCertSub:BehaviorSubject<any> = new BehaviorSubject('loading');
  private profileCertObs$:Observable<any> = this.profileCertSub.asObservable()
  
  setProfileCert(data:any):void{
    this.profileCertSub.next(data);
  }
  getProfileCertObs():Observable<any>{
    return this.profileCertObs$;
  }

  private profileSkillSub:BehaviorSubject<any> = new BehaviorSubject('loading');
  private profileSkillObs$:Observable<any> = this.profileSkillSub.asObservable()
  
  setProfileSkill(data:any):void{
    this.profileSkillSub.next(data);
  }

  getProfileSkillObs():Observable<any>{
    return this.profileSkillObs$;
  }

  private profileSoftSkillSub:BehaviorSubject<any> = new BehaviorSubject('loading');
  private profileSoftSkillObs$:Observable<any> = this.profileSoftSkillSub.asObservable()
  
  setProfileSoftSkill(data:any):void{
    this.profileSoftSkillSub.next(data);
  }

  getProfileSoftSkillObs():Observable<any>{
    return this.profileSoftSkillObs$;
  }

  private profileAwardSub:BehaviorSubject<any> = new BehaviorSubject('loading');
  private profileAwardObs$:Observable<any> = this.profileAwardSub.asObservable()
  
  setProfileAward(data:any):void{
    this.profileAwardSub.next(data);
  }

  getProfileAwardObs():Observable<any>{
    return this.profileAwardObs$;
  }

  private profileVoluntarySub:BehaviorSubject<any> = new BehaviorSubject('loading');
  private profileVoluntaryObs$:Observable<any> = this.profileVoluntarySub.asObservable()
  
  setProfileVoluntary(data:any):void{
    this.profileVoluntarySub.next(data);
  }

  getProfileVoluntaryObs():Observable<any>{
    return this.profileVoluntaryObs$;
  }

  private profileBookSub:BehaviorSubject<any> = new BehaviorSubject('loading');
  private profileBookObs$:Observable<any> = this.profileBookSub.asObservable()
  
  setProfileBook(data:any):void{
    this.profileBookSub.next(data);
  }

  getProfileBookObs():Observable<any>{
    return this.profileBookObs$;
  }

  private profileProjectSub:BehaviorSubject<any> = new BehaviorSubject('loading');
  private profileProjectObs$:Observable<any> = this.profileProjectSub.asObservable()
  
  setProfileProject(data:any):void{
    this.profileProjectSub.next(data);
  }

  getProfileProjectObs():Observable<any>{
    return this.profileProjectObs$;
  }

  private profileLanguageSkillSub:BehaviorSubject<any> = new BehaviorSubject('loading');
  private profileLanguageSkillObs$:Observable<any> = this.profileLanguageSkillSub.asObservable()
  
  setProfileLanguageSkill(data:any):void{
    this.profileLanguageSkillSub.next(data);
  }
  getProfileLanguageSkillObs():Observable<any>{
    return this.profileLanguageSkillObs$;
  }

  addNewAdditionalData(additional_data:any){
    return this.http.post(`${this.BASE_URL}user_role/user_additional_data/` , additional_data )
  }
  addNewStudentInfo(studentData:any){
    return this.http.post(`${this.BASE_URL}user_role/student_role/` , studentData )
  }
  addNewCertification(certificate:any){
    return this.http.post(`${this.BASE_URL}user_role/certification_role/` , certificate )
  }
  addNewEmployee(employee:any){
    return this.http.post(`${this.BASE_URL}user_role/employee_role/` , employee )
  }
  addNewProject(project:any){
    return this.http.post(`${this.BASE_URL}user_role/project_role/` , project )
  }
  addNewLanguageSkill(language:any){
    return this.http.post(`${this.BASE_URL}user_role/language_skill_role/` , language )
  }
  addNewSoftSkill(software:any){
    return this.http.post(`${this.BASE_URL}user_role/software_skill/` , software )
  }
  addNewSkill(skill:any){
    return this.http.post(`${this.BASE_URL}user_role/skill_role/` , skill )
  }
  addNewVoluntary(voluntary:any){
    return this.http.post(`${this.BASE_URL}user_role/voluntary_activity_role/` , voluntary )
  }
  addNewAward(award:any){
    return this.http.post(`${this.BASE_URL}user_role/award_role/` , award )
  }
  addNewBook(book:any){
    return this.http.post(`${this.BASE_URL}user_role/book_role/` , book )
  }
  /////get
  getCertifications(username:string):Observable<any>{
    return this.http.get<AllProfileDetail>(`${this.BASE_URL}user_role/${username}/get_roles/?type=CERTIFICATION&ordering=-id`).pipe(
      map((data:AllProfileDetail)=>data.CERTIFICATION)
    )
  }
  getEmployees(username:string){
    return this.http.get<AllProfileDetail>(`${this.BASE_URL}user_role/${username}/get_roles/?type=EMPLOYEE&ordering=-id`).pipe(
      map((data:AllProfileDetail)=>data.EMPLOYEE)
    )
  }
  getLanguageSkills(username:string){
    return this.http.get<AllProfileDetail>(`${this.BASE_URL}user_role/${username}/get_roles/?type=LANGUAGE_SKILL&ordering=-id`).pipe(
      map((data:AllProfileDetail)=>data.LANGUAGE_SKILL)
    )
  }
  getLanguageById(id:number){
    return this.http.get(`${this.BASE_URL}user_role/language/?id=${id}`)
  }
  getSkills(username:string){
    return this.http.get<AllProfileDetail>(`${this.BASE_URL}user_role/${username}/get_roles/?type=SKILL&ordering=-id`).pipe(
      map((data:AllProfileDetail)=>data.SKILL)
    )
  }
  getProjects(username:string){
    return this.http.get<AllProfileDetail>(`${this.BASE_URL}user_role/${username}/get_roles/?type=PROJECT&ordering=-id`).pipe(
      map((data:AllProfileDetail)=>data.PROJECT)
    )
  }
  getBook(username:string){
    return this.http.get<AllProfileDetail>(`${this.BASE_URL}user_role/${username}/get_roles/?type=BOOK&ordering=-id`).pipe(
      map((data:AllProfileDetail)=>data.BOOK)
    )
  }
  getSoftware(username:string){
    return this.http.get<AllProfileDetail>(`${this.BASE_URL}user_role/${username}/get_roles/?type=SOFTWARE_SKILL&ordering=-id`).pipe(
      map((data:AllProfileDetail)=>data.SOFTWARE_SKILL)
    )
  }
  getAward(username:string){
    return this.http.get<AllProfileDetail>(`${this.BASE_URL}user_role/${username}/get_roles/?type=AWARD&ordering=-id`).pipe(
      map((data:AllProfileDetail)=>data.AWARD)
    )
  }
  getVoluntary(username:string){
    return this.http.get<AllProfileDetail>(`${this.BASE_URL}user_role/${username}/get_roles/?type=VOLUNTARY_ACTIVITY&ordering=-id`).pipe(
      map((data:AllProfileDetail)=>data.VOLUNTARY_ACTIVITY)
    )
  }
  getStudentsInfo(username:string){
    return this.http.get<AllProfileDetail>(`${this.BASE_URL}user_role/${username}/get_roles/?type=STUDENT&ordering=-id`).pipe(
      map((data:AllProfileDetail)=>data.STUDENT),
    )
  }
  getUserAdditionalData(username:string){
    return this.http.get(`${this.BASE_URL}user_role/user_additional_data/specific_user/${username}/`)
  }
  private userAdditionalSub:BehaviorSubject<any> = new BehaviorSubject('loading');
  private userAdditionalObs$:Observable<any> = this.userAdditionalSub.asObservable()
  
  setUserAdditional(data:any):void{
    this.userAdditionalSub.next(data);
  }
  getUserAdditionalObs():Observable<any>{
    return this.userAdditionalObs$;
  }
  /// edit
  editCertification(id:string,data:any){
    return this.http.patch(`${this.BASE_URL}user_role/certification_role/${id}/` , data )    
  }
  editUserAditionalData(id:string,data:any){
    return this.http.patch(`${this.BASE_URL}user_role/user_additional_data/${id}/` , data )    
  }
  editUserAditionalDataWithPatch(id:string,data:any){
    return this.http.post(`${this.BASE_URL}user_role/user_additional_data/` , data )    
  }
  editStudent(id:string,data:any){
    return this.http.patch(`${this.BASE_URL}user_role/student_role/${id}/` , data )    
  }
  editSkillRole(id:string,data:any){
    return this.http.patch(`${this.BASE_URL}user_role/skill_role/${id}/` , data )    
  }
  editVoluntaryRole(id:string,data:any){
    return this.http.patch(`${this.BASE_URL}user_role/voluntary_activity_role/${id}/` , data )    
  }
  editAwardRole(id:string,data:any){
    return this.http.patch(`${this.BASE_URL}user_role/award_role/${id}/` , data )    
  }
  editBookRole(id:string,data:any){
    return this.http.patch(`${this.BASE_URL}user_role/book_role/${id}/` , data )    
  }
  editLanguageSkillRole(id:string,data:any){
    return this.http.patch(`${this.BASE_URL}user_role/language_skill_role/${id}/` , data )    
  }
  editSoftSkillRole(id:string,data:any){
    return this.http.patch(`${this.BASE_URL}user_role/software_skill/${id}/` , data )    
  }
  editEployee(id:string,data:any){
    return this.http.patch(`${this.BASE_URL}user_role/employee_role/${id}/` , data )    
  }
  editProject(id:string,data:any){
    return this.http.patch(`${this.BASE_URL}user_role/project_role/${id}/` , data )    
  }
  /////delete
  deleteCertificationRole(id:string){
    return this.http.delete(`${this.BASE_URL}user_role/certification_role/${id}/` )
  }
  deleteEmployeeRole(id:string){
    return this.http.delete(`${this.BASE_URL}user_role/employee_role/${id}/` )
  }
  deleteLanguageSkill(id:string){
    return this.http.delete(`${this.BASE_URL}user_role/language_skill_role/${id}/` )
  }
  deleteSoftwareSkill(id:string){
    return this.http.delete(`${this.BASE_URL}user_role/software_skill/${id}/` )
  }
  deleteAward(id:string){
    return this.http.delete(`${this.BASE_URL}user_role/award_role/${id}/` )
  }
  deleteBook(id:string){
    return this.http.delete(`${this.BASE_URL}user_role/book_role/${id}/` )
  }
  deleteProject(id:string){
    return this.http.delete(`${this.BASE_URL}user_role/project_role/${id}/` )
  }
  deleteVoluntary(id:string){
    return this.http.delete(`${this.BASE_URL}user_role/voluntary_activity_role/${id}/` )
  }
  deleteSkillRole(id:string){
    return this.http.delete(`${this.BASE_URL}user_role/skill_role/${id}/` )
  }
  deleteStudentRole(id:string){
    return this.http.delete(`${this.BASE_URL}user_role/student_role/${id}/` )
  }
  sortCert(certList:any){
    if(certList=='loading') return [];
    if(certList.length<1){
      return certList
    }
    let list = certList.sort(
      (a:any,b:any)=>{
        if(a.additional_data.end_date > b.additional_data.end_date){
          return -1
        }else if(a.additional_data.end_date == b.additional_data.end_date){
          if(a.additional_data.start_date > b.additional_data.start_date){
            return -1;
          }else if(a.additional_data.start_date == b.additional_data.start_date){
            return 0;
          }else{
            return 1;
          }
        }else{
          return 1
        }
      }
    )
    let activeList:any = []
    let deactiveList:any = []
    list.forEach((item:any)=>{
      if(item.additional_data.end_date==0){
        activeList.push(item)
      }else{
        deactiveList.push(item)
      }
    })
    return activeList.concat(deactiveList);
    // return list;
  }
  sortEmployee(jobList:any){
    if(jobList=='loading') return [];
    if(jobList.length<1){
      return jobList
    }else{
      let list = jobList.sort(
        (a:any,b:any)=>{
          if(a.additional_data.end_date > b.additional_data.end_date){
            return -1
          }else if(a.additional_data.end_date == b.additional_data.end_date){
            if(a.additional_data.start_date > b.additional_data.start_date){
              return -1;
            }else if(a.additional_data.start_date == b.additional_data.start_date){
              return 0;
            }else{
              return 1;
            }
          }else{
            return 1
          }
        }
      )
      let activeList:any = []
      let deactiveList:any = []
      list.forEach((item:any)=>{
        if(item.additional_data.end_date==1){
          activeList.push(item)
        }else{
          deactiveList.push(item)
        }
      })
      return activeList.concat(deactiveList);
    }
  }
  setProfileSetting(setting:any){
    this.profileSettingSubject.next(setting) 
  }
  getProfileSetting(): Observable<ProfileSetting>{
    return this.profileSettingObs.pipe(
      filter(data=>data!=null && data!=undefined)
    )
  }

  getFieldOfStudyById(id:number):Observable<any>{
    return this.http.get(`${this.BASE_URL}user_role/generic_field/?type=STUDENT&id=${id}`)
  }
  getUniversityById(id:number):Observable<any>{
    return this.http.get(`${this.BASE_URL}place/university/?id=${id}`)
  }
  resetProfileHeader(stu:boolean=true, job:boolean=true):void{
    let interval$ = interval(300).subscribe({
      next: ()=>{
        console.log('next profile header')
        if(stu)
          this.setProfileStu([])
        if(job)
          this.setProfileJob([])
      }
    })
    merge(
      this.getProfileStuObs().pipe(take(2)),
      this.getProfileJobObs().pipe(take(2)),
    ).subscribe({
      complete: ()=>interval$.unsubscribe()
    })
  }
  private currentDegreeSub:BehaviorSubject<any> = new BehaviorSubject('loading');
  private currentJobSub:BehaviorSubject<any> = new BehaviorSubject('loading');

  private currentDegreeObs$:Observable<any> = this.currentDegreeSub.asObservable()
  private currentJobObs$:Observable<any> = this.currentJobSub.asObservable()
  setCurrentDegreeSub(current:any){
    this.currentDegreeSub.next(current)
  }
  setCurrentJobSub(current:any){
    this.currentJobSub.next(current)
  }

  getCurrentJobObs(){
    return this.currentJobObs$
  }
  getCurrentDegreeObs(){
    return this.currentDegreeObs$
  }

  // set current field
  setCurrentDegree() {
    return this.getProfileStuObs().pipe(
      switchMap(data => from(data).pipe(
        filter((data: any) => data.is_public),
        toArray(),
      )),
      map((data: any[]) => data.length ? data[0] : 'empty'),
      tap((i:any)=>{
        if(i=='empty') this.setCurrentDegreeSub({})
        if(i!='empty'){
          if(i.additional_data.uni_username) this.setCurrentDegreeSub({name:i.additional_data.uni_username.name, username:i.additional_data.uni_username.username})
          if(!i.additional_data.uni_username) this.currentDegreeSub.next({name:i.additional_data.school, username:null})
        }
      })
    ).subscribe()
  }
  setCurrentJob() {
    return this.getProfileJobObs().pipe(
      switchMap(data => from(data).pipe(
        filter((data: any) => data.is_public && data.additional_data.end_date && data.additional_data.end_date == 1),
        toArray(),
      )),
      map((data: any[]) => {
        return data.length ? data[0] : 'empty'
      }),
      tap((i:any)=>{
        if(i=='empty') this.setCurrentJobSub({})
        if(i!='empty'){
          if(i.additional_data.organ_username) this.setCurrentJobSub({name:i.additional_data.organ_username.name, username:i.additional_data.organ_username.username})
          if(!i.additional_data.organ_username) this.setCurrentJobSub({name:i.additional_data.company_name, username:null})
        }
      })
    ).subscribe()
  }
  patchProfileCurrent(type:'job'|'edu',data:any){
    let formData:any = new FormData();
    if(type=='edu') {
      return this.getCurrentDegreeObs().pipe(
        mergeMap((degree:any)=>{
          formData.append('current_university',JSON.stringify(degree))
          return this.editProfile(formData).pipe(
            map(()=>{return data})
          )     
        })
      )
    }
    else {
      return this.getCurrentJobObs().pipe(
        mergeMap((job:any)=>{
          formData.append('current_job',JSON.stringify(job))
          return this.editProfile(formData).pipe(
            map(()=>{return data})
          )     
        })
      )
    }
  }
  editProfile(data: Profile) {
    return this.http.patch<Profile>(`${this.BASE_URL}auth/users/me/`, data)
  }
}